import { useLocation, matchPath } from "react-router-dom";
import SeoHead from "@/components/SeoHead";
import {
  STATIC_ROUTE_SEO,
  isNoindexPath,
  policySeoForSlug,
  absoluteUrl,
} from "@/lib/seoConfig";
import { globalSchemaGraph } from "@/lib/seoSchema";

const POLICY_SLUGS = ["terms", "privacy", "shipping", "returns", "contact"];

export default function RouteSeo() {
  const { pathname, search } = useLocation();
  const noindex = isNoindexPath(pathname);

  if (matchPath("/product/:id", pathname)) return null;
  if (matchPath("/category/:slug", pathname)) return null;
  if (pathname.startsWith("/search")) {
    const q = new URLSearchParams(search).get("q") || "";
    return (
      <SeoHead
        title={q ? `Search: ${q} | OORI Label` : "Search | OORI Label"}
        description={
          q
            ? `Search results for "${q}" at OORI Label.`
            : "Search OORI Label for kurtis, co-ords, tops & more."
        }
        canonical={absoluteUrl(q ? `/search?q=${encodeURIComponent(q)}` : "/search")}
        noindex
        jsonLd={globalSchemaGraph()}
      />
    );
  }

  const policyMatch = matchPath("/policies/:slug", pathname);
  if (policyMatch?.params?.slug && POLICY_SLUGS.includes(policyMatch.params.slug)) {
    const seo = policySeoForSlug(policyMatch.params.slug);
    return (
      <SeoHead
        {...seo}
        canonical={absoluteUrl(pathname)}
        noindex={noindex}
        jsonLd={globalSchemaGraph()}
      />
    );
  }

  const staticSeo = STATIC_ROUTE_SEO[pathname];
  if (staticSeo) {
    return (
      <SeoHead
        {...staticSeo}
        canonical={absoluteUrl(pathname)}
        noindex={noindex}
        jsonLd={globalSchemaGraph()}
      />
    );
  }

  return (
    <SeoHead
      canonical={absoluteUrl(pathname)}
      noindex={noindex}
      jsonLd={globalSchemaGraph()}
    />
  );
}
